import React, {Component} from 'react';
import Contribution from './Contribution';
import './Research.css';

class Research extends Component {

    constructor(props) {

        super(props);
        this.state = {
            research: undefined,
            attempts: 1,
        };

    }

    componentDidMount(){

        if(this.state.research === undefined)
            this.downloadResearch();

    }

    render() {

        if(this.state.research === undefined)
            return <div></div>;

        var body = [];

        for(var groupName in this.state.research){

            var group = this.state.research[groupName];
            var contributions = group.map((contribution)=>{
                return <Contribution key={contribution.info.key} data={contribution}/>
            });

            body.push(
                <div key={"group"+groupName} className="Group">
                    <div className="GroupName">{groupName}</div>
                    {contributions}
                </div>);

        }

        return (
            <div className="Research">
                {body}
            </div>
        );

    }

    downloadResearch(){

        var caller = this;

        return fetch('https://www.andreagerino.com/431387eb7262e1cfc79b125eb8a67c60/proxy.php')
        //return fetch(process.env.PUBLIC_URL +'/research.json')
            .then((response) => response.json())
            .then((responseJson) => {

                this.props.readyCallback(true);

                caller.setState({research: caller.sortResearch(responseJson['result']['hits']['hit'])});


            }).catch((error) => {

                if (caller.state.attempts < 3) {

                    caller.setState({
                        attempts: caller.state.attempts + 1
                    })

                    caller.downloadResearch();

                }

                this.props.readyCallback(false, caller.state.attempts < 3);

            });

    }

    sortResearch(research){

        var researchByType = {};

        for(var key in research){

            var info = research[key]['info'];
            var type = info['type'];

            var typeArray = researchByType[type];
            if(typeArray===undefined){
                typeArray = [];
                researchByType[type] = typeArray;

            }

            typeArray.push(research[key]);

        }

        var temp = researchByType["Informal Publications"];
        delete researchByType["Informal Publications"]
        researchByType["Informal Publications"] = temp;

        return researchByType;


    }

}

export default Research;



// WEBPACK FOOTER //
// ./src/Research.js